// extracted by mini-css-extract-plugin
module.exports = {"discount":"discount___3V47s"};